export default __webpack_public_path__ + "static/media/person.f8ed3107.svg";